(function(contra, $, undefined) {
	'use strict';
 
	var matchTallest = function(feature){
		
		var tallest = 0;
			feature.each(function(i,val){
				var $thisH = $(this).height();
				if($thisH > tallest){
					tallest = $thisH;
				}
			});
			feature.each(function() {
				$(this).height(tallest);
			});

	};

	contra.init = function() {
		// Initialize functionality here
	};

})(window.contra = window.contra || {}, jQuery);

jQuery(document).ready(function () {
	window.contra.init();
});